module.exports = __webpack_public_path__ + "c06fb50818487c931d5b0d84589d5494.jpg";